import React, { useEffect, useState } from 'react';
import PumpStatus from '../components/datausage/PumpStatus';
import TemperatureValues from '../components/datausage/TemperatureValues';
import ConsumptionData from '../components/datausage/ConsumptionData';
import DropdownSelector from '../components/DropdownSelector';
import { useTranslation } from 'react-i18next';
import { useBuilding } from '../context/buildingContext';
import { fetchApi } from '../utils/fetchApi';

const DataUsage: React.FC = () => {
  const { t } = useTranslation();
  const { buildingId, apartmentId } = useBuilding();
  const [selectedMonth, setSelectedMonth] = useState<string | null>(null);
  const [monthlyData, setMonthlyData] = useState<any[]>([]);
  const [actualData, setActualData] = useState<any>(null);
  const [waterStatus, setWaterStatus] = useState<any>(null);
  const [consumptionData, setConsumptionData] = useState<any[]>([]);
  const [temperatureValues, setTemperatureValues] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchAnalyticsData = async () => {
      if (!buildingId || !apartmentId) {
        setError(t('error.invalidBuildingOrApartment'));
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);
        const data = await fetchApi(
          `/building_management/building/${buildingId}/apartment/${apartmentId}/montly_analytics`
        );
        setMonthlyData(data.monthly || []);
        setActualData(data.actual[0] || null);
        setWaterStatus(data.water_status);

        // Set default month and data
        if (data.monthly && data.monthly.length > 0) {
          const firstMonth = data.monthly[0];
          setSelectedMonth(firstMonth.interval); // Store the raw interval value
          setConsumptionData(formatConsumptionData(firstMonth));
        }
      } catch (err) {
        console.error('Error fetching analytics data:', err);
        setError(t('error.fetchFailed'));
      } finally {
        setLoading(false);
      }
    };

    fetchAnalyticsData();
  }, [buildingId, apartmentId, t]);

  useEffect(() => {
    if (selectedMonth && monthlyData.length > 0) {
      const selectedMonthData = monthlyData.find((entry) => entry.interval === selectedMonth);
      if (selectedMonthData) {
        setConsumptionData(formatConsumptionData(selectedMonthData));
      }
    }
  }, [selectedMonth, monthlyData]);

  const formatConsumptionData = (monthData: any) => [
    { label: 'Fűtés halmozott hőmennyiség', value: `${monthData.heating_quantity} kWh` },
    { label: 'Fűtés aktuális havi hőmennyiség', value: `${monthData.used_heating_quantity} kWh` },
    { label: 'Hűtés halmozott hőmennyiség', value: `${monthData.cooling_quantity} kWh` },
    { label: 'Hűtés aktuális havi hőmennyiség', value: `${monthData.used_cooling_quantity} kWh` },

    { label: 'HMV halmozott hőmennyiség', value: `${monthData.hotwater_heating_quantity} kWh` },
    { label: 'HMV aktuális havi hőmenny', value: `${monthData.used_hotwater_heating_quantity} kWh` },
    { label: 'HMV elhasznált vízmennyiség', value: `${monthData.hotwater_usage} m³` },
    { label: 'HMV aktuális havi felhasz.', value: `${monthData.used_hotwater} m³` },

    { label: 'HV elhasznált vízmennyiség', value: `${monthData.coldwater_usage} m³` },
    { label: 'HV aktuális havi felhasz.', value: `${monthData.used_coldwater} m³` },

  ];

  const dropdownOptions = monthlyData
    .slice()
    .sort((a, b) => new Date(b.interval).getTime() - new Date(a.interval).getTime()) // Sort by date descending
    .reduce(
      (acc: Record<string, string>, entry: any) => ({
        ...acc,
        [entry.interval]: new Date(entry.interval).toLocaleDateString('hu-HU', {
          year: 'numeric',
          month: 'long',
        }),
      }),
      {}
    );

  // Set the default selectedMonth to the most recent interval
  useEffect(() => {
    if (monthlyData.length > 0) {
      const latestMonth = monthlyData[0].interval;
      setSelectedMonth(latestMonth);
      setConsumptionData(formatConsumptionData(monthlyData[0]));
    }
  }, [monthlyData]);

  useEffect(() => {
    console.log(actualData)
    if (actualData) {
      setTemperatureValues([
        {
          label: 'Előremenő víz hőmérséklete fűtés/hűtés',
          temperature: waterStatus.forwarding_water_temperature,
        },
        {
          label: 'Visszatérő víz hőmérséklete fűtés/hűtés',
          temperature: waterStatus.returning_water_temperature,
        },
        {
          label: 'HMV víz hőmérséklete',
          temperature: waterStatus.domestic_hot_water_temperature,
        },
      ]);
    }
  }, [actualData]);

  // TODO
  return (<h3>Fejlesztés alatt</h3>);

  return (
    <div className="dataUsage">
      {error ? (
        <p className="error">{error}</p>
      ) : loading ? (
        <p>{t('loading')}</p>
      ) : (
        <>
          <PumpStatus
            status={waterStatus?.pump_status === 0 ? t('inactive') : t('active')}
            description=''
          />
          <TemperatureValues values={temperatureValues} />
          <DropdownSelector
            label={t('currentMonth')}
            onChange={(month) => setSelectedMonth(month)}
            value={selectedMonth || ''}
            options={dropdownOptions}
          />
          <ConsumptionData data={consumptionData} />
        </>
      )}
    </div>
  );
};

export default DataUsage;


/*

  const temperatureValues = [
    { label: 'Előremenő víz hőmérséklete fűtés/hűtés', temperature: 24 },
    { label: 'Visszatérő víz hőmérséklete fűtés/hűtés', temperature: 22 },
    { label: 'HMV víz hőmérséklete', temperature: 23 },
  ];

  const consumptionData = [
    { label: 'Fűtés halmozott hőmennyiség', value: '1200 kWh' },
    { label: 'Fűtés aktuális havi hőmennyiség', value: '800 kWh' },
    { label: 'Hűtés halmozott hőmennyiség', value: '1100 kWh' },
    { label: 'Hűtés aktuális havi hőmennyiség', value: '1300 kWh' },
    { label: 'HMV hőmennyiség', value: '1800 kWh' },
    { label: 'HMV felhasznált vízmennyiség', value: '80 m³' },
    { label: 'HV elhasznált vízmennyiség', value: '60 m³' },
  ];
*/